<template>
  <div>
    <el-cascader v-if="fieldName=='groupId'" v-model="values" class="arriveClass orgList" :placeholder="Language('请选择')" :show-all-levels="false" clearable filterable ref="cascader"
     :options="orgList" :props="{ expandTrigger: 'hover',label:'orgName', value: 'orgId',checkStrictly: true }" @change="orgChange"
     style="width:100%;display:inline-block;" :disabled="editType=='examine'||editType=='info'||editType=='return'||(orderStatus&&orderStatus!='0')"></el-cascader>
    <el-cascader v-else-if="fieldName=='labMsg'" v-model="values" class="arriveClass orgList" :placeholder="Language('请选择')" :show-all-levels="false" clearable filterable ref="cascader"
     :options="labList" :props="{ expandTrigger: 'hover',label:'labName', value: 'id',checkStrictly: true }" @change="orgChange"
     style="width:100%;display:inline-block;" :disabled="editType=='examine'||editType=='info'||editType=='return'"></el-cascader>
    <el-select v-else style="width:100%;" v-model="values" clearable @change="selectChange"
      :disabled="editType=='examine'||editType=='info'||editType=='return'||(fieldNameList.indexOf(fieldName)>-1&&orderStatus&&orderStatus!='0')||(editType=='hotline'&&(fieldName=='originType'||fieldName=='originId'))"
      filterable :multiple="dataMultiple==2?true:false" :placeholder="Language('请选择')" default-first-option>
      <!-- 客户 -->
      <template v-if="fieldName=='cusId'">
        <el-option v-for="item in options" :key="item.id" :label="item.cusName" :value="item.id"> </el-option> 
      </template>
      <!-- 客户公司 -->
      <template v-if="fieldName=='cId'">
        <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"> </el-option>
      </template>
      <!-- 人员、创建人 -->
      <template v-else-if="fieldName=='userId'||fieldName=='createOper'">
        <el-option v-for="item in options" :key="item.userId" :label="item.agentName" :value="item.userId"> </el-option>
      </template>
      <!-- 工单状态 -->
      <template v-else-if="fieldName=='status'">
        <el-option v-for="(item, index) in statusList" :key="index" :label="item" :value="index"> </el-option>
      </template>
      <!-- 客户等级、优先级、工单类型 -->
      <template v-else-if="fieldName=='levelCode'||fieldName=='priorityCode'||fieldName=='orderTypeCode'">
        <el-option v-for="item in options" :key="item.code" :label="item.name" :value="item.code"> </el-option>
      </template>
      <!-- 渠道 -->
      <template v-else-if="fieldName=='originId'">
        <el-option v-for="(item, index) in originList" :key="index" :label="item.originName" :value="item.originId"> </el-option>
      </template>
      <!-- 字典模板 -->
      <template v-else>
        <el-option v-for="item in filterData" :key="item.dictCode" :label="item.dictName" :value="item.dictCode"></el-option>
      </template>
    </el-select>
  </div>
</template>

<script>
	import { getOrgList, getUserList } from '@/http/BranchManagement.js'
  import { getSessionLableList } from "@/http/EmailManagement.js"
  import { getChannelList } from "@/http/BaseData.js"

  export default {
    props: ['dataOrigin', 'placeholderLoad', 'dataMultiple', 'inputType', 'fieldName', 'editType', 'filterData', 'orderStatus'],
    data() {
      return {
        options: [],
        orgList: [],
        labList: [],
        originList: [],
        fieldNameList: ['userId', 'originType', 'originId', 'vId', 'nikeName', 'sourceId'],
        values: '',
        optionList: {},
        vdnId: '',
        statusList: {
          0: '暂存', 1: '开启', 2: '已分配', 3: '处理中', 4: '已解决', 5: '回访中', 6: '待回访', 7: '已回访', 8: '关闭'
        }
      }
    },
    watch: {
      
    },
    mounted() {
      const self = this
      this.vdnId = JSON.parse(LocalStorage.getItem("obj")).vdnId
      self.optionList = JSON.parse(LocalStorage.getItem('optionList'))||{}
      setTimeout(function() {
        self.initDataList()
      })
    },
    created() {
    },
    methods: {
      initDataList() {
        if (this.fieldName=='cId') this.options = this.optionList['cusCompany']
        else if (this.fieldName=='groupId') this.orgList = this.optionList['orgList']
        else if (this.fieldName=='userId'||this.fieldName=='createOper') this.options = this.optionList['userList']
        else if (this.fieldName=='levelCode') this.options = this.optionList['cusLevel']
        else if (this.fieldName=='priorityCode') this.options = this.optionList['priorityCode']
        else if (this.fieldName=='cusId') this.options = this.optionList['customer']
        else if (this.fieldName=='orderTypeCode') this.options = this.optionList['orderType']
        else if (this.fieldName=='labMsg') this.fetchLabList()
      },
      orgChange(data){
        this.$refs.cascader.toggleDropDownVisible()//点击收起
        if (this.fieldName == 'groupId') this.$emit('changeOrgFn', data)
      },
      selectChange(data) {
        if (this.fieldName=='cId') this.$emit('selectChange', data, this.fieldName)
        if (this.fieldName=='originType') this.$emit('originTypeChange', data, this.fieldName)
        if (this.fieldName=='priorityCode') this.$emit('priorityCodeChange', data, this.fieldName)
      },
      //获取渠道
      fetchOriginListFn(data) {
        getChannelList({
          vdnId: this.vdnId,
          originType: data
        }).then(res => {
          if(res && res.retCode == 1){
            this.originList = res.data
          }
        })
      },
      //获取人员列表
      fetchUserListFn(data, type) {
        if(!data){
          this.userList =[]
          return
        } 
        let params = {
          orgId: data[data.length - 1],
          userKey: '',
          vdnId: this.vdnId
        }
        getUserList(params).then(res => {
          if(res && res.retCode == 1){
            this.options = res.data.filter(item => { return item.flag == 1})
            if (!type) this.values = ''
            if (type == 'solveSelf') this.values = JSON.parse(LocalStorage.getItem("obj")).userId
          }
        })
      },
      //获取标签信息
      fetchLabList() {
        getSessionLableList({
          vdnId: this.vdnId,
          labName: ''
        }).then(res => {
          if (res && res.retCode == 1) {
            this.labList = res.data
          }
        })
      },
    }
  }
</script>



// WEBPACK FOOTER //
// SelectList.vue?25ccfa72